import { useState, useEffect, useCallback } from 'react';
import { Product } from '../types';
import ProductService from '../services/product-service';
import HttpClientRequest from '../api/client-request';

export const useProducts = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);


  const requestId = new Date().getTime().toString();

  const fetchProducts = useCallback(async () => {

    try {
      
      setLoading(true);
      const fetchedProducts =  await ProductService.getProducts(requestId);
      setProducts(fetchedProducts);
      
    } catch (error) {
      setError('Failed to fetch products');
    }
    finally {
      setLoading(false);
    }

  }, [requestId])

  useEffect(() => {

    void fetchProducts();

    return () => {
      
      HttpClientRequest.cancelRequest(requestId); // Cancel the request if needed

      setProducts([]);
      setLoading(false);
      setError(null);
    }
  }, []);

  return { products, loading, error };
};